import { render, staticRenderFns } from "./BrokerSaasAgreement.vue?vue&type=template&id=7cfb53b5&scoped=true"
import script from "./BrokerSaasAgreement.vue?vue&type=script&lang=js"
export * from "./BrokerSaasAgreement.vue?vue&type=script&lang=js"
import style0 from "./BrokerSaasAgreement.vue?vue&type=style&index=0&id=7cfb53b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfb53b5",
  null
  
)

export default component.exports